import * as React from 'react';
import { MergeSubscriberGroupContainerProps } from 'app/area/subscriber-groups/shared/merge-subscriber-group/types';
import { MergeSubscriberGroupModal } from 'app/area/subscriber-groups/shared/merge-subscriber-group/merge-subscriber-group-modal';
import { replaceTemplateString } from 'app/infrastructure/platform';

export const MergeSubscriberGroupContainer = (props: MergeSubscriberGroupContainerProps) => {

  const {
    mergeSubscriberGroup, updateMergeSubscriberGroup, translation, validation, subscriberGroupOptions,
    loadOptions, resetValidation, updateValidation
  } = props;

  const deleteMergeSubscriberGroupItem = (uncheckSelectItem: boolean) => {
    const { mergeSubscriberGroup: { id, name, reassignReferencesToCode: { value = undefined } = {} }, deleteMergeSubscriberGroup } = props;

    deleteMergeSubscriberGroup({
      id,
      ...(!uncheckSelectItem && { reassignReferencesToCode: value }),
      successMessage: replaceTemplateString(translation.subscriber_group_deleted, name)
    });
  };

  const onClose = () => updateMergeSubscriberGroup({ ...mergeSubscriberGroup, showMergeSubscriberGroup: false });

  return mergeSubscriberGroup?.showMergeSubscriberGroup
    && <MergeSubscriberGroupModal
      mergeSubscriberGroup={mergeSubscriberGroup}
      updateMergeSubscriberGroup={updateMergeSubscriberGroup}
      options={subscriberGroupOptions}
      loadOptions={loadOptions}
      translation={translation}
      validation={validation}
      deleteMergeSubscriberGroupItem={deleteMergeSubscriberGroupItem}
      onClose={onClose}
      resetValidation={resetValidation}
      updateValidation={updateValidation} />;
};
